import dateformat from "dateformat";
import uhaulStore from "./CustomRedux/UhaulStore";
import {
    updateSupervisorStatistics,
    updateWorkers,
    updateTaskQueueCategories,
    updateTaskBackLogs,
    updateReservations
} from "./Components/Actions/SupervisorStatisticsActions";
import { updateCustomerDataList } from "./Components/Actions/CRMActions";
import ExceptionLogger from "./ExceptionHelper";
import getMonitoredInfo from "./Mapping";
import GetLiveChatHeader from "./LiveChatHeaderHelper";

export {
    TriggerDataRefresh,
    GetAllWorkers,
    RefreshReservations,
    GetRealTimeTasks,
    GetCustomerData,
    CallCMGTAPI,
    GetSearchTerm
};

/*7/31/19 - C Lam - Task #556205: Live Chat - Refactor the Supervisor Dashboard */
function TriggerDataRefresh(serviceBaseUrl, liveChatApiUrl, sessionId, allCategories, selectedCategory, useSupervisorAttributes, getAllTasks) {
    var firstActions = [], secondActions = [], thirdActions = [];
    firstActions.push(new Promise(resolve => setTimeout(() => resolve(
        getRealTimeStatistics(serviceBaseUrl, liveChatApiUrl, sessionId, allCategories, selectedCategory, useSupervisorAttributes)
    ), 100)));

    if (getAllTasks) {
        secondActions.push(new Promise(resolve => setTimeout(() => resolve(
            GetRealTimeTasks(serviceBaseUrl, allCategories, useSupervisorAttributes, selectedCategory)
        ), 100)));

        thirdActions.push(new Promise(resolve => setTimeout(() => resolve(
            RefreshReservations(serviceBaseUrl)
        ), 100)));
    }

    var results = Promise.all(firstActions);
    results.then(() => {

        var secondResults = Promise.all(secondActions);
        secondResults.then(() => {
            Promise.all(thirdActions);
        })
    }).catch((err) => {
        console.log("ERROR: ", err);
        ExceptionLogger(err, "RefreshStats.js", "Error with TriggerDataRefresh", "", "");
    });
}

function getRealTimeStatistics(serviceBaseUrl, liveChatApiUrl, sessionId, allCategories, selectedCategory, useSupervisorAttributes) {
    if (!serviceBaseUrl || !liveChatApiUrl || !sessionId) return;

    if (allCategories == null) allCategories = []
    let requestURI = `${liveChatApiUrl}Statistics/${sessionId}`;
    console.log("getRealTimeStatistics");
    fetch(requestURI,
        {
            method: "GET",
            headers: GetLiveChatHeader()
        })
        .then(response => {
            if (!response.ok) {
                ExceptionLogger(null, "getRealTimeStatistics", "Fetch failed", "", response, true)
            }
            return response.json()
        })
        .then(json => {
            if (json?.length > 0) {
                const workers = uhaulStore.getState().UhaulReducer.workers ?? GetAllWorkers(serviceBaseUrl);
                const formattedDate = dateformat(new Date(), "mm/dd/yyyy");
                const todayDate = new Date(formattedDate);

                const fn = function getTasks(stats) {
                    if (stats?.friendlyName == null) return;

                    let foundLoggedInWorkers = null;
                    if (workers?.length > 0) {
                        foundLoggedInWorkers = workers.filter(x => x.activityName !== "Offline" && x.attributes.includes(stats.friendlyName.toLowerCase()) && (new Date(x.dateStatusChanged) >= todayDate || new Date(x.dateUpdated) >= todayDate));
                    }
                    stats["total_loggedIn_workers"] = foundLoggedInWorkers?.length ?? 0;

                    if (allCategories.length <= 0 || !allCategories.includes(stats.category)) {
                        allCategories.push(stats.category);
                    }
                };

                json = json.sort(function (a, b) { return a.category - b.category });

                var actions = json.map(fn);
                var results = Promise.all(actions);
                results.then(() => {
                    if (allCategories != null) {
                        allCategories = allCategories.filter(item => item != "All").sort(); // Filter out "All" because we want it to be the first item
                        allCategories.unshift("All"); // Re-add ALL as the first item
                    }
                    uhaulStore.dispatch(updateSupervisorStatistics(json));
                    uhaulStore.dispatch(updateTaskQueueCategories((allCategories)));
                });
            } else {
                uhaulStore.dispatch(updateSupervisorStatistics(json));
                //uhaulStore.dispatch(updateFilterSelection(selectedCategory));
                uhaulStore.dispatch(updateTaskQueueCategories((allCategories)));
            }
        })
        .catch((err) => {
            console.log("ERROR: Unable to get stats");
            ExceptionLogger(err, "getRealTimeStatistics", `Unable to fetch from ${requestURI}`);
        });
}

/*1/11/19 - C Lam - Task #467800: Live Chat - Add Filters to Dashboard*/
function GetRealTimeTasks(serviceBaseUrl, allCategories, useSupervisorAttributes, selectedCategory) {
    if (selectedCategory === null) {
        selectedCategory = uhaulStore.getState().UhaulReducer.currentSelectedCategory;
    }

    if (allCategories == null) allCategories = [];
    if (!allCategories.includes("All")) {
        allCategories.push("All");
    }

    let numOfTasks = 0;
    let firstActions = [];

    firstActions.push(new Promise(resolve => setTimeout(() => resolve(
        fetch(serviceBaseUrl + "get-all-tasks",
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                method: "GET",
                body: new URLSearchParams({
                    Token: Manager.getInstance().user.token,
                })
            })
            .then(response => {
                if (!response.ok) {
                    ExceptionLogger(null, "GetRealTimeTasks", "GetAllTasks Fail", "", response, true);
                }
                return response.json();
            })
            .then(result => {
                uhaulStore.dispatch(updateTaskBackLogs(result));
            })
            .catch(err => {
                ExceptionLogger(err, "GetRealTimeTasks", "GetAllTasks Fetch Error");
            })
    ), 100)));

    var results = Promise.all(firstActions);
    results.then(() => {
        const result = uhaulStore.getState().UhaulReducer.supervisorTasks;
        if (!result || result.length <= 0) return;

        let resultedWorkers = uhaulStore.getState().UhaulReducer.workers;
        numOfTasks = result.length;
        const allMonitoredTasks = result.filter(task => task.taskQueueFriendlyName !== null && task.taskQueueFriendlyName.includes("Supervisor-"));
        const lsWorkers = getMonitoredInfo(allMonitoredTasks, result.filter(task => task.assignmentStatus !== "completed" && (selectedCategory !== null ? (selectedCategory === "All" ? task !== null : task.categories.filter(category => category === selectedCategory)) : task !== null)));
        const supervisorUser = uhaulStore.getState().UhaulReducer.currentUser;  //get current user information

        const fn = function getReservations(task) {

            if (task !== null && !task.sid.includes("dup")) {
                task["category"] = (task !== null && task.categories !== null && task.categories.length > 0) ? task.categories[0] : "";

                if (useSupervisorAttributes || (selectedCategory === null || selectedCategory.trim() === ""))//if we are using the supervisor's attributes to filter the stats
                {
                    if (supervisorUser !== null && supervisorUser.queues !== null) {
                        if (task.taskQueueFriendlyName !== null && supervisorUser.queues.includes(task.taskQueueFriendlyName.toLowerCase())) {
                            selectedCategory = task.category;
                        }
                    }
                }

                if (resultedWorkers != null && resultedWorkers.length > 0) {
                    resultedWorkers.forEach(worker => {
                        var foundName = task["assignedAgent"];
                        if (worker.friendlyName === foundName) {
                            var parsedWrkAttr = JSON.parse(worker.attributes)
                            task["assignedAgent"] = parsedWrkAttr.full_name;
                        }
                    });
                }

                if (task["assignedAgent"] === null || task["assignedAgent"] === "") {
                    if (task.attributes !== null) {
                        var parsedAttributes = JSON.parse(task.attributes);
                        if (parsedAttributes !== null && parsedAttributes["agent"] !== null && parsedAttributes["agent"].trim() !== "") {
                            task["assignedAgent"] = parsedAttributes["agent"];
                        }
                    }

                    if (task["assignedAgent"] === null || task["assignedAgent"] === "") {
                        return new Promise(resolve => setTimeout(() => resolve(
                            fetch(serviceBaseUrl + "get-workers-by-task",
                                {
                                    headers: {
                                        'Content-Type': 'application/x-www-form-urlencoded'
                                    },
                                    method: "POST",
                                    body: new URLSearchParams({
                                        Token: Manager.getInstance().user.token,
                                        TaskSid: task.sid
                                    })
                                })
                                .then(response => response.json())
                                .then(json => {
                                    var agentName = "";
                                    if (json != null && json.length > 0) {
                                        if (json[json.length - 1] !== null && json[json.length - 1].trim() !== "") {
                                            agentName = json[json.length - 1];
                                        }
                                    }
                                    return agentName !== null ? agentName : "N/A";
                                })
                                .then((agentName) => {
                                    task["assignedAgent"] = agentName;
                                })
                        ), 100));
                    }
                }

                if (task.categories?.length > 0) {
                    task.categories.forEach(category => {
                        if (allCategories.length <= 0 || (!allCategories.includes(category) && category !== "")) {
                            allCategories.push(category);
                        }
                    });
                }
            }
        };

        var actions = result.map(fn);
        var results = Promise.all(actions);
        results.then(() => {
            uhaulStore.dispatch(updateTaskBackLogs(result));
            uhaulStore.dispatch(updateTaskBackLogs(lsWorkers));
        });

    }).catch((err) => {
        console.log("ERROR: ", err);
        ExceptionLogger(err, "getRealTimeTasks", "Error with getRealTimeTasks", "", `${selectedCategory}`);
    });

    return numOfTasks;
}

function RefreshReservations(serviceBaseUrl) {
    GetAllWorkers(serviceBaseUrl);
    var foundTasks = { ...uhaulStore.getState().UhaulReducer.supervisorTasks };

    if (foundTasks != null && foundTasks.length > 0) {
        foundTasks.forEach(element => {
            if (element.assignedAgent != null) {
                element["agentName"] = element.assignedAgent;
            }
        });

        uhaulStore.dispatch(updateReservations(foundTasks));
    }
    else {
        defaultGetAllTaskReservations(serviceBaseUrl);
    }
}

function defaultGetAllTaskReservations(serviceBaseUrl) {
    fetch(serviceBaseUrl + "get-all-tasks",
        {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            method: "POST",
            body: new URLSearchParams({
                Token: Manager.getInstance().user.token,
            })
        })
        .then(response => response.json())
        .then(result => {
            uhaulStore.dispatch(updateTaskBackLogs(result));
            return result;
        });
}

function GetAllWorkers(serviceBaseUrl) {
    fetch(serviceBaseUrl + "get-all-workers",
        {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            method: "POST",
            body: new URLSearchParams({
                Token: Manager.getInstance().user.token,
            })
        })
        .then(response => response.json())
        .then(json => {
            uhaulStore.dispatch(updateWorkers(json));
            uhaulStore.dispatch(updateReservations(json));
        });
}

function GetCustomerData(props) {
    try {
        const customerDataList = uhaulStore.getState().UhaulReducer.customerDataList;
        const hasNoSavedCustomerData = !customerDataList || !customerDataList.length || customerDataList.length <= 0;
        const hasTaskProps = props && props.task && props.task.attributes;

        if (hasNoSavedCustomerData && hasTaskProps) {
            CallCMGTAPI(props);
        }
        else if (hasTaskProps) {
            var searchTerm = GetSearchTerm(props);
            if (!customerDataList.find(x => x.SearchTerm === searchTerm)) {
                CallCMGTAPI(props);
            }
        }
    }
    catch (e) {
        ExceptionLogger(e, "GetCustomerData", "Error attempting to retrieve Customer Data", null, "");
    }
}

function updateCustomerDataListWithErrorMessage(errorMessage) {
    try {
        var list = [{ "Exception": errorMessage }];
        uhaulStore.dispatch(updateCustomerDataList(list));
    }
    catch (e) {
        ExceptionLogger(e, "updateCustomerDataList dispatch", "Error executing updateCustomerDataList dispatch.", null, "");
    }
}

function CallCMGTAPI(props) {
    try {
        const searchTerm = GetSearchTerm(props);
        if (!searchTerm) return;

        // The API WILL reject the Fetch if there's no Session UID
        const currentUser = uhaulStore.getState().UhaulReducer.currentUser;
        if(currentUser?.sessionGuid == null) {
            console.log("CMGT Fail: No Session UID")
            return;
        }
        const sessionGuid = currentUser.sessionGuid;
        const sid = currentUser.sid ?? "";
        const workerName = currentUser.workerName ?? "";
        const requestUri = `${uhaulStore.getState().UhaulReducer.config.cmgtApiUrl}?sessionID=${sessionGuid}&searchTerm=${searchTerm}`

        let initialActions = [];
        initialActions.push(new Promise(resolve => setTimeout(() => resolve(
            fetch(requestUri,
                {
                    method: "GET",
                    headers: GetLiveChatHeader()
                })
                .then(response => {
                    if (response && response.ok) {
                        var result = response.text();
                        if (result) {
                            return result.then((data) => {
                                console.log("response", data)
                                try {
                                    return { "json": JSON.parse(data) };
                                } catch (e) {
                                    return { "notJson": data };
                                }
                            })
                        }
                    }

                    ExceptionLogger(null, "CallCMGTAPI", "Cannot fetch initial actions", "", response, true)
                    throw new Error("Error with CMGT API");
                })
                .then(foundData => {
                    console.log("foundData", foundData)

                    if (foundData) {
                        if (foundData.json) {
                            foundData.json.SearchTerm = searchTerm;

                            var customerDataList = uhaulStore.getState().UhaulReducer.customerDataList;

                            if (customerDataList && !customerDataList.find(x => x.SearchTerm == searchTerm)) {
                                customerDataList.push(foundData.json);
                                uhaulStore.dispatch(updateCustomerDataList(customerDataList));
                            }
                            else if (!customerDataList) {
                                var list = [foundData.json];
                                uhaulStore.dispatch(updateCustomerDataList(list));
                            }
                        }
                        else if (foundData.notJson) {
                            updateCustomerDataListWithErrorMessage(foundData.notJson);
                        }
                    }
                    else {
                        uhaulStore.dispatch(updateCustomerDataList([]));
                    }
                })
                .catch(error => {
                    updateCustomerDataListWithErrorMessage("There was an error with retrieving customer data. Please refresh this page.");
                    ExceptionLogger(error, "CallCMGTAPI", "Error with fetching Customer Data.", null, "SearchTerm: " + searchTerm + ", Agent's name: " + workerName + ", Agent's SID: " + sid);
                })
            , 100))));

        Promise.all(initialActions)
            .catch(error => {
                updateCustomerDataListWithErrorMessage("There was an error with retrieving customer data. Please refresh this page.");
                ExceptionLogger(error, "CallCMGTAPI", "Error with fetching Customer Data.", null, "SearchTerm: " + searchTerm + ", Agent's name: " + workerName + ", Agent's SID: " + sid);
            });
    }
    catch (e) {
        updateCustomerDataListWithErrorMessage("There was an error with retrieving customer data. Please refresh this page.");
        ExceptionLogger(e, "CallCMGTAPI", "Error with fetching Customer Data.", null, "");
    }
}

/*Returns a search term */
function GetSearchTerm(props) {
    var custName = "", phoneNumber = "", email = "";
    if (props && props.task && props.task.attributes) {
        custName = props.task.attributes.name;
        phoneNumber = props.task.attributes.phoneNumber;
        email = props.task.attributes.email;
    }
    else if (props && props.props && props.props.task && props.props.task.attributes) {
        custName = props.props.task.attributes.name;
        phoneNumber = props.props.task.attributes.phoneNumber;
        email = props.props.task.attributes.email;
    }

    if (email && email.trim() !== "") {
        return email;
    }
    else if (phoneNumber && phoneNumber.trim() !== "") {
        phoneNumber = phoneNumber.replace(/\D/g, '');
        return phoneNumber;
    }
    else if (custName && custName.trim() !== "") {
        return custName;
    }
    else {
        return "";
    }
}
